import { render, staticRenderFns } from "./BaseStack.vue?vue&type=template&id=51cebb63&"
import script from "./BaseStack.vue?vue&type=script&lang=js&"
export * from "./BaseStack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports